import React from "react";

 //@ts-ignore
 export const getTextFromElement = (element) => {
    const childrenArray = React.Children.toArray(element.props.children);
    
    return childrenArray
     //@ts-ignore
      .map(child => {
        if (typeof child === 'string') {
          return child;
        } else if (React.isValidElement(child)) {
          return getTextFromElement(child);
        }
        return '';
      })
      .join(''); 
  }import React from "react";

 //@ts-ignore
 export const getTextFromElement = (element) => {
    const childrenArray = React.Children.toArray(element.props.children);
    
    return childrenArray
     //@ts-ignore
      .map(child => {
        if (typeof child === 'string') {
          return child;
        } else if (React.isValidElement(child)) {
          return getTextFromElement(child);
        }
        return '';
      })
      .join(''); 
  }